module.exports = __webpack_public_path__ + "static/media/Cuadricula_2-gris.132cbeb2.svg";